module.exports = __webpack_public_path__ + "static/media/empty.91661969.svg";